
import {useAdminContext} from "../../contexts/AdminContext"
import { IoIosBoat } from "react-icons/io";


interface BoatListByUserProps {
    userId: string
}

const BoatListByUser: React.FC<BoatListByUserProps> = ({userId}) => {

    const {tabIdBoats, tabIdUser2Boat} = useAdminContext();

    return(
        <div className={`transition-all duration-300 ease-in-out`}>
            {!tabIdUser2Boat ? null: 
                (<ul>
                    {
                    tabIdUser2Boat[userId].length ?
                        tabIdUser2Boat[userId]?.map((boatId) => {
                            return(
                                <li key={boatId} className="d-flex align-items-center justify-content-between g-2"> 
                                    <IoIosBoat/> {tabIdBoats[boatId].code}
                                </li>
                            )
                        })
                        : "Aucun bateau"
                    }
                </ul>
            )}
        </div>
    );
}

export default BoatListByUser;